import { AppQueryProvider, AuthBoundary } from "@pustak-lms/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "@pustak-lms/ui/styles.css";
import "./styles.css";
import { App } from "./App";

const router = createBrowserRouter([{ path: "*", element: <AuthBoundary mode="platform">{(identity) => <App identity={identity} />}</AuthBoundary> }]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppQueryProvider>
      <RouterProvider router={router} />
    </AppQueryProvider>
  </StrictMode>
);
